import { useState } from 'react';

import { useForm } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { fetchLogin } from '../../slices/auth.slice';
import { useAppDispatch } from '../../store/hooks';
import { LoginDetails } from '../../types/auth';
import { getStorageValue } from '../../utils/cookies';
import LoginWrapper from './LoginWrapper';

const Login = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  const { control, handleSubmit } = useForm<LoginDetails>({
    mode: 'all',
    defaultValues: {  userName: '', password: '', token: '' },
  });

  const onSubmit = async(data: LoginDetails) => {
    setLoading(true);
    const cookieStorageKey = `$_${data.userName}`.toLowerCase();
    await dispatch(fetchLogin({ loginReqDetails: { ...data, token: getStorageValue(cookieStorageKey)|| "",customerCode:"" }, navigate, toast }));
    setLoading(false);
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <LoginWrapper control={control} isApiLoading={loading} />
    </form>
  );
};

export default Login;
